/**
 * @generated SignedSource<<cc5dc8b60a748fe70305a7fc73f54704>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeLeave_widgetEmployeeLeave$data = {
  readonly employeesOnLeave: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeLeaveItem_item">;
  }>;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "WidgetEmployeeLeave_widgetEmployeeLeave";
};
export type WidgetEmployeeLeave_widgetEmployeeLeave$key = {
  readonly " $data"?: WidgetEmployeeLeave_widgetEmployeeLeave$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeLeave_widgetEmployeeLeave">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeLeave_widgetEmployeeLeave",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetEmployeeLeaveItem",
      "kind": "LinkedField",
      "name": "employeesOnLeave",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetEmployeeLeaveItem_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetEmployeeLeave",
  "abstractKey": null
};
})();

(node as any).hash = "5411aeb3776f3875c7784dd198087f9f";

export default node;
